import EditClinic from './EditStore'
import {connect} from 'react-redux';
import * as action from '../../state/detail/action'
import * as selector from '../../state/detail/selector'

const mapStateToProps = (state, props) => {
    return {
        title:'Edit Clinic',
        store: selector.selectStore(state),
        validationMessageList: selector.selectValidationMessageList(state),
        storeId: props.computedMatch.params.storeId,
        redirect:selector.selectRedirect(state),
        isFetching: selector.selectIsFetching(state)
    }
}

const mapDispatchToProps = {
    findStore: action.findStore,
    editStore: action.editFormValue,
    saveStore: action.createOrUpdateStore,
    pushValidationList: action.pushValidationList,
    clearState:action.clearState
}

export default connect(mapStateToProps, mapDispatchToProps)(EditClinic)



// WEBPACK FOOTER //
// ./src/modules/store/component/edit/EditStoreContainer.js